import { render, staticRenderFns } from "./bagging.vue?vue&type=template&id=062b2a9c&scoped=true&"
import script from "./bagging.vue?vue&type=script&lang=js&"
export * from "./bagging.vue?vue&type=script&lang=js&"
import style0 from "./bagging.vue?vue&type=style&index=0&id=062b2a9c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "062b2a9c",
  null
  
)

export default component.exports